import { Image } from "../types/image";
export const isSameFile = (
  file: Pick<Image, "originalFileName" | "size">,
  compageFile: Pick<Image, "originalFileName" | "size">
) =>
  file.originalFileName === compageFile.originalFileName &&
  file.size === compageFile.size;
